import {Component, input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PanelModule} from 'primeng/panel';
import {HashMap} from '@jsverse/transloco';
import {PanelHeaderComponent} from '../panel-header/panel-header.component';

@Component({
  selector: 'app-panel',
  imports: [CommonModule, PanelModule, PanelHeaderComponent],
  templateUrl: './app-panel.component.html',
})
export class AppPanelComponent {
  titleKey = input.required<string>();
  titleParams = input<HashMap<string | number>>({});
  tooltipKey = input<string>();
  icon = input<string>();
  iconColor = input<string>();

  collapsed = input<boolean>(false);
  toggleable = input<boolean>(true);
}
